<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { Snippet } from 'svelte';

  type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';
  type Size = 'sm' | 'md' | 'lg';

  interface Props {
    variant?: Variant;
    size?: Size;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    fullWidth?: boolean;
    ariaLabel?: string;
    onclick?: (event: MouseEvent) => void;
    children?: Snippet;
  }

  let {
    variant = 'primary',
    size = 'md',
    disabled = false,
    type = 'button',
    fullWidth = false,
    ariaLabel,
    onclick,
    children,
  }: Props = $props();

  const base =
    'inline-flex items-center justify-center font-semibold rounded-xl transition active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-indigo-400/30';

  const variants: Record<Variant, string> = {
    primary:
      'bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-400 hover:to-purple-400 text-white shadow-lg shadow-indigo-500/25',
    secondary: 'bg-white/10 hover:bg-white/20 text-white',
    danger: 'bg-red-500 hover:bg-red-400 text-white shadow-lg shadow-red-500/30',
    ghost: 'bg-transparent hover:bg-white/5 text-slate-200',
  };

  const sizes: Record<Size, string> = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-base px-4 py-2.5',
    lg: 'text-base px-5 py-3.5',
  };
</script>

<button
  {type}
  {disabled}
  aria-label={ariaLabel}
  class="{base} {variants[variant]} {sizes[size]} {fullWidth ? 'w-full' : ''}"
  onclick={(e) => onclick?.(e)}
>
  {@render children?.()}
</button>
